import { useState, useCallback } from 'react';
import { api } from './api';
import { useApiStatus } from './useApiStatus';
import { ConfigType } from '../../models/api.interface';
import axios from 'axios';

export const useQuery = <BodyData, ResponseData>(
  // <BodyData> and <ResponseData> are "generic types" that are passed so that we can expect
  // to send/receive whatever data we want when we use this hook.
  verb: 'post' | 'patch' | 'get',
  query: string,
  config?: ConfigType,
) => {
  const { apiStatus, setApiStatus, ...normalizedStatuses } = useApiStatus();
  const [data, setResponseData] = useState<ResponseData | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [errorStatus, setErrorStatus] = useState<number | null>(null);

  const endpoint = api<BodyData, ResponseData>(verb, query, config);

  const exec = useCallback(
    async (data: BodyData) => {
      try {
        setApiStatus('PENDING');
        setErrorStatus(null);
        const response = await endpoint(data);
        setResponseData(response);
        setApiStatus('SUCCESS');
        return response;
      }
      catch (error: any) {
        if (axios.isAxiosError(error)) {
          setError(error.message);
          setErrorStatus(error.response?.status ?? null);
        }
        else setError(error);
        setApiStatus('ERROR');
      }
    },
    [config, query],
  );

  return { data, error, errorStatus, exec, apiStatus, setApiStatus, ...normalizedStatuses };
};
